import {useAppSelector} from "../../../../../../../redux/hooks";
import {
  getDoesMySongsLibraryUserLibraryIncludeLessonId
} from "../../../../../modules/my-songs-library-store/mySongsLibrary.selector";

export interface IWhenLessonNotInUserLibraryLogic {
  isLessonInUserLibrary: boolean;
}

export const useWhenLessonNotInUserLibraryLogic = (lessonId: number): IWhenLessonNotInUserLibraryLogic => {
  const isLessonInUserLibrary = useAppSelector(() => getDoesMySongsLibraryUserLibraryIncludeLessonId(lessonId));

  return {
    isLessonInUserLibrary,
  };
}
